﻿'use strict';

angular.module('ntmApp').factory('ColumnDependencies',[ 'ListGridHelper', 'ListGridStatus', function (ListGridHelper, ListGridStatus) {

    function ColumnDependencies() {
        var self = this;
        self.hasDependent = false;
        self.dependentIDs = [];
        self.dependentMap = new Map();
        self.dependentColumnCondition = new Map();

        self.init = function (fieldName, dependentArr) {
            if (self.hasDependencies(dependentArr)) {
                var dependentColumns = [];
                dependentArr.forEach(function (item) {
                    self.dependentIDs.push(item.attributeId);
                    ListGridStatus.columns.forEach(function (column) {
                        if (column.attributeId === item.attributeId) {
                            dependentColumns.push(column);
                            updateMap(column.attributeId, item, fieldName);
                        }
                    });
                });

                self.dependentMap.set(fieldName, dependentColumns);
            }
        };

        self.hasDependencies = function (dependentArr) {
            return dependentArr && dependentArr.length > 0;
        };

        self.prepareRequestData = function (dependentColumn, field, model, infoTabModel) {
            var result = {};

            var columnConditions = self.dependentColumnCondition.get(dependentColumn.attributeId);
            if(!columnConditions) { 
                return;
            }

            result.id = dependentColumn.attributeId;
            result.values = [];
            result.infoTabValues = [];

            columnConditions.forEach(function (columnCondition) {

                var column = ListGridHelper.getColumnByFieldName(columnCondition.fieldName);
                if (!column) {
                    return;
                }

                /*var modelValue =  model[column.fieldName] || model[column.name];
                if(field.propertyObj.groupBy && field.attributeId === 413826 && modelValue){
                    var keyValue =  modelValue.split('/');
                    var propertyValue = field.values.filter(v => v[field.propertyObj.groupBy] === keyValue[0] && v[field.propertyObj.display[0]] === keyValue[1])[0];                    
                    modelValue = propertyValue ? propertyValue[field.propertyObj.key] : modelValue;
                }*/

                var entity = ListGridHelper.getValueByKey(column,  model[column.fieldName] || model[column.name]);
                if (!entity) {
                    return;
                }

                if (columnCondition.condition && angular.isArray(columnCondition.condition)) {

                    columnCondition.condition.forEach(function (conditionItem) {

                        var value = {
                            field: conditionItem.field || column.propertyObj.key,
                            value: conditionItem.parentField ? entity[conditionItem.parentField] : entity[column.propertyObj.key],
                            operator: conditionItem.operator || '='
                        };

                        updateMap(dependentColumn.attributeId, columnCondition, columnCondition.fieldName, value);

                        if (self.dependentColumnCondition.get(column.attributeId)) {

                            var conditions = self.dependentColumnCondition.get(column.attributeId);

                            conditions.forEach(function (condition) {
                                result.values = result.values.concat(angular.copy(condition.values || []));
                            });
                        }

                        result.values.push(value);
                    });
                } else {

                    var value = {
                        field: columnCondition.condition.field || column.propertyObj.key,
                        value: columnCondition.condition.parentField ? entity[columnCondition.condition.parentField] : entity[column.propertyObj.key],
                        operator: columnCondition.condition.operator || '='
                    };

                    updateMap(dependentColumn.attributeId, columnCondition, columnCondition.fieldName, value);

                    if (self.dependentColumnCondition.get(column.attributeId)) {

                        var conditions = self.dependentColumnCondition.get(column.attributeId);

                        conditions.forEach(function (condition) {
                            result.values = result.values.concat(angular.copy(condition.values || []));
                        });
                    }

                    result.values.push(value);
                }                

                Object.keys(infoTabModel).forEach(function (key) {
                    if (infoTabModel[key] && ListGridHelper.getColumnByFieldName(key) && result.values.filter(function (val) { return val.field === key; }).length === 0) {
                        result.infoTabValues.push({
                            field: key,
                            value: infoTabModel[key],
                            operator: '='
                        });
                    }
                });

            });

            return result;
        };

        function updateMap(attributeId, item, fieldName, values) {
            if (self.dependentColumnCondition.has(attributeId)) {
                var value = self.dependentColumnCondition.get(attributeId);

                if (value.filter(function (val) { return val.fieldName === fieldName; }).length === 0) {
                    value.push({ condition: item.condition, fieldName: fieldName, values: values });
                    self.dependentColumnCondition.set(attributeId, value);
                }
            } else {
                self.dependentColumnCondition.set(attributeId, [{ condition: item.condition, fieldName: fieldName, values: null }]);
            }
        }
    }

    return (ColumnDependencies);
}]);